// extracted by mini-css-extract-plugin
export default {"cls1":"O4K8LVcKaHEt3s62VcYU","cls2":"sJDsxm4ZBCiVXxk_USQB O4K8LVcKaHEt3s62VcYU"};